export default __webpack_public_path__ + "static/media/onboarding-1.62dae9ed.png";